module.exports = __webpack_public_path__ + "static/img/Icon3.ee3b84e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon3.png
// module id = e4QB
// module chunks = 7